import { z } from "zod";

import fetch from "@lib/fetch";

import type { RemoteLookupProvider } from "./providers";
import type { SearchFetcher, SearchParams, SearchResult } from "./types";

export function createSearchFetcher<T extends string = string, Id = unknown, Item = unknown, Filters = unknown>(
  type: T,
  provider: RemoteLookupProvider<Id, Item, Filters>
): SearchFetcher<Item, Filters> {
  const paramsSchema = z.object({
    app_group_id: z.string(),
    query: z.string(),
    filters: provider.validators.filters,
    page_index: z.number().int().nonnegative(),
  });
  const resultSchema = z.object({
    items: z.array(provider.validators.item),
    has_next_page: z.boolean(),
  });
  return async (signal: AbortSignal, params: SearchParams<Filters>): Promise<SearchResult<Item>> => {
    const parsedParams = paramsSchema.parse(params);
    const result = await fetch(
      `/remote_lookup/${parsedParams.app_group_id}/${type}/search`,
      "POST",
      {
        query: parsedParams.query,
        filters: parsedParams.filters,
        page_index: parsedParams.page_index,
      },
      { signal }
    );
    return resultSchema.parse(result);
  };
}
